import React, { useEffect, useState } from 'react';
import Modal from '../components/modal/modal.component';
import Card from '../components/card.component';

const ConfirmAlertV2 = ({ show , onConfirm = null, onCancel = null, message, buttonText = "Confirmar", typeBtn="button", buttonCancel = "Cerrar" }) => {

  const [visible, setVisible] = useState(show);

  const toggle = () => {
      setVisible(!visible)
      if (onCancel !== null) {
        onCancel();
      }
  }

  useEffect(() => {
    setVisible(show);
  },[show])

  const confirmarbutton = () => {
      toggle();
      onConfirm();
  }

  return (
    <>
    { typeBtn === 'button' ? 
     <button 
        type="button"
        className="btnx btnx-warn icon-table"
        onClick={toggle}
      >
        {buttonText}
    </button>
    : null }
    <Modal size="xs" show={visible}>
      <Card>
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <p style={{ fontWeight: 'bold' }}> ¿Confirma la operación? </p>
          <div style={{ marginBottom: 15 }}>{message}</div>
        </div>
        <div>
          <button 
            onClick={toggle}
            type="button"
            className="btnx btnx-warn"
           >
             {buttonCancel}
           </button>
           {' '}
           <button 
            onClick={() => confirmarbutton()}
            type="button"
            className="btnx btnx-warn"
           >
             {buttonText}
           </button>
        </div>
       </Card>
    </Modal>
    </>
  )
}

export default ConfirmAlertV2;